import React from 'react';
import Component from '@vfuk/core-picker';
const Picker = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default Picker;
